

import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { SecondaryButton } from "@/components/Buttons/SecondaryButton";
import { Spacing } from "@/components/Spacing/Spacing";
import { useTranslations } from "next-intl";
import { IconAlertCircle } from "@tabler/icons-react";
import { Link } from "react-router-dom";

export const ChangePasswordError: React.FC = () => {
  const t = useTranslations("changePassword");

  return (
    <div className="flex flex-col items-center w-full" data-testid="change-password-invalid-token">
      <IconAlertCircle size={48} stroke={1.5} className="font-error" />
      <Spacing height="h-4" />
      <p className="body-1-regular text-center">{t("linkExpiredMessage")}</p>
      <Spacing height="h-6" />
      <Link to="/auth/reset-password" className="w-full">
        <PrimaryButton size="small" text={t("requestNewLink")} />
      </Link>
      <Spacing height="h-3" />
      <Link to="/auth/login" className="w-full">
        <SecondaryButton size="small" text={t("goHome")} />
      </Link>
    </div>
  );
};
